<template>
        <div>
            <div class="px-4 fs-16 fw-500 ml-1 text-primary-shade">
                <span class="highlighted">Facility Management</span> 
            </div>
            <div class="center-content">
                <div class="preview-elements py-3">
                    <ul class="nav nav-tabs nav-fill nav-profile" id="myTab" role="tablist">
                        <li class="nav-item">
                            <a @click="changeView('configure_shift')" class="nav-link text-capitalize" role="tab" aria-controls="configureshift" aria-expanded="true" aria-selected="false" v-bind:class="{ active: configure_shift}">
                                <h6>Configure Shift </h6>
                            </a>
                        </li>
                        <!-- <li class="nav-item">
                            <a @click="changeView('emergency_contact')" class="nav-link mb-2 text-capitalize" role="tab" aria-controls="emergencycontact" aria-expanded="true" aria-selected="false" v-bind:class="{ active: emergency_contact}">
                                <h6>Emergency Contact</h6>
                            </a>
                        </li> -->
                        <li class="nav-item">
                            <a @click="changeView('reports_generation_schedule')" class="nav-link mb-2 text-capitalize" role="tab" aria-controls="reportsgenerationschedule" aria-expanded="true" aria-selected="false" v-bind:class="{ active: reports_generation_schedule}">
                                <h6>Reports Generation Schedule</h6>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a @click="changeView('configure_qr_code')" class="nav-link mb-2 text-capitalize" role="tab" aria-controls="configureqrcode" aria-expanded="true" aria-selected="false" v-bind:class="{ active: configure_qr_code}">
                                <h6>Configure QR Code</h6>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a @click="changeView('facility_area_location_setup')" class="nav-link mb-2 text-capitalize" role="tab" aria-controls="facilityarealocationsetup" aria-expanded="true" aria-selected="false" v-bind:class="{ active: facility_area_location_setup}">
                                <h6 class="text-capitalize">Facility Area & Location Setup</h6>
                            </a>
                        </li>
                    </ul>
                    <div class="tab-content profile-tab-content scroll-media" id="myTabContent" >
                        <div class="" id="configure_shift" aria-labelledby="configureshift-tab" v-if="configure_shift" style="color:white">
                            <configure-shift ></configure-shift>
                        </div>
                        <div class="" id="reports_generation_schedule" aria-labelledby="reportsgenerationschedule-tab" v-if="reports_generation_schedule">
                            <reports-generation-schedule></reports-generation-schedule>
                        </div>
                        <div class="" id="configure_qr_code" aria-labelledby="configureqrcode-tab" v-if="configure_qr_code">
                            <configure-qr-code></configure-qr-code>
                        </div>
                        <div class="" id="facility_area_location_setup" aria-labelledby="facilityarealocationsetup-tab" v-if="facility_area_location_setup">
                            <facility-area-and-location></facility-area-and-location>
                        </div>
                        <div class="" id="emergency_contact" aria-labelledby="emergencycontact-tab" v-if="emergency_contact">
                            <list-emergency-contact></list-emergency-contact>
                        </div>
                    </div>
                </div>
            </div>
        </div>
</template>
<script>
import QrcodeVue from "qrcode.vue";
import { HalfCircleSpinner } from "epic-spinners";
import { EventBus } from '../../eventBus/nav-bar-event';
const ConfigureShift = () => import('./ConfigureShift');
const ReportsGenerationSchedule = () => import('./ReportsGenerationSchedule');
const ConfigureQrCode = () => import('./ConfigureQrCode');
const FacilityAreaAndLocation = () => import('./FacilityAreaAndLocation.vue')
const ListEmergencyContact = () => import('./ListEmergencyContact.vue')
export default {
    components:{
        HalfCircleSpinner,
        QrcodeVue,
        ConfigureShift,
        ReportsGenerationSchedule,
        ConfigureQrCode,
        FacilityAreaAndLocation,
        ListEmergencyContact
    },
    data(){
        return{
            ajaxCallinprogress:false,
            profile_data:{},
            valueqr: "https://example.com",
            size: 90,
            configure_shift:true,
            reports_generation_schedule:false,
            configure_qr_code:false,
            facility_area_location_setup:false,
            emergency_contact: false
        }
    },
    methods:{
        changeView(value){
            if(value == 'configure_shift'){
                this.configure_shift = true
                this.reports_generation_schedule = false
                this.configure_qr_code = false
                this.emergency_contact = false;
                this.facility_area_location_setup = false
            }else if(value == 'reports_generation_schedule'){
                this.configure_shift = false
                this.reports_generation_schedule = true
                this.configure_qr_code = false
                this.emergency_contact = false;
                this.facility_area_location_setup = false
            }else if(value == 'configure_qr_code'){
                this.configure_shift = false
                this.reports_generation_schedule = false
                this.configure_qr_code = true
                this.emergency_contact = false;
                this.facility_area_location_setup = false
            }else if(value == 'facility_area_location_setup'){
                this.configure_shift = false
                this.reports_generation_schedule = false
                this.configure_qr_code = false
                this.emergency_contact = false;
                this.facility_area_location_setup = true
            }else if(value == 'emergency_contact'){
                this.configure_shift = false
                this.reports_generation_schedule = false
                this.configure_qr_code = false
                this.facility_area_location_setup = false
                this.emergency_contact = true;
            }
        }
    },
    mounted(){
        // if(this.$route.params && this.$route.params.id){
        //     let value = this.$route.params.id
        //     this.changeView(value)
        // }
        // EventBus.$on('updateSettingView',value=>{
        //     this.changeView(value)
        // })
    },
    destroyed(){
        // EventBus.$off('updateSettingView')
    },
    computed:{    
        loggedInUser() {
            return this.$store.state.store.loggedInUser
        },
    }
}
</script>
<style scoped>
.text-blue-new{
    color:#00448b;

}
.inner-line-hr{
    border: 0;
    width: 100%;
    border-top: 0.5px solid #b2bec3;
}
.nav-tabs.nav-profile .nav-link.active,
.nav-tabs.nav-profile .nav-item.show .nav-link {
    color: #00448b;
    background-color: transparent;
}

.nav-tabs.nav-profile .nav-link.active:not(.dropdown-toggle):after,
.nav-tabs.nav-profile .nav-item.show .nav-link:not(.dropdown-toggle):after {
    background-color: transparent !important;
    content: none !important;
}

.nav.nav-tabs.nav-profile {
    width: 100%;
    background: transparent;
    border-radius: 0px 0px 0px 0px;
    display: inline-block;
    flex-direction: column;
    overflow-y: hidden;
    overflow-x: auto;
    /* max-height: 8em; */
    border-bottom: 0.5px solid #130e0e !important;
}

.nav-tabs.nav-profile .nav-link.active {
    overflow: visible;
}

.nav-tabs.nav-profile .nav-link:hover,
.nav-tabs.nav-profile .nav-link:focus {
    border-color: #00448b;
}

.nav-tabs.nav-profile .nav-link {
    position: relative;
    display: block;
    height: 48px !important;
    margin-right: 10px;
    line-height: 48px;
    margin-right: 10px;
    color: #00448b;
}

.nav-tabs.nav-profile .nav-link.active,
.nav-tabs.nav-profile .nav-item.show .nav-link {
    font-weight: bold;
    border-bottom: 2px solid #00448b;

}

.nav-tabs.nav-profile .nav-link img {
    display: inline-block;
    text-align: center;
    margin: 8px auto 6px;
}

.nav-tabs.nav-profile .nav-link i {
    display: inline-block;
    text-align: center;
    margin: 12px auto 6px;
    font-size: 16px !important;
    width: 42px;
    height: 14px;
    line-height: 14px;
    color: #808495;
}

.nav-tabs.nav-profile .nav-link.active i,
.nav-tabs.nav-profile .nav-item.show .nav-link i {
    font-weight: bold;
}

.nav-tabs.nav-profile .nav-link:hover i,
.nav-tabs.nav-profile .nav-link:focus i {
    font-weight: bold;
}

.nav-tabs.nav-profile .nav-link h6 {
    display: inline-block;
    font-size: 14px;
    text-align: center;
    font-weight: 600;
    color: #00448b;
}

.nav-tabs.nav-profile .nav-link.active h6,
.nav-tabs.nav-profile .nav-item.show .nav-link h6 {
    font-weight: bold;
}

.nav-tabs.nav-profile .nav-link:hover h6,
.nav-tabs.nav-profile .nav-link:focus h6 {
    font-weight: bold;
}

.tab-content.profile-tab-content {
    padding: 10px 0px;
    overflow-y: auto;
    overflow-x: hidden;
}

.pointerEventsNone {
    pointer-events: none !important;
}
.nav li.nav-item{
    min-width: 15%;
    display: inline-block;
    cursor: pointer;
}
</style>